import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Axios from '../../Axios';
import { toast } from 'react-toastify';
import { updateLoader } from '../../Redux/loaderSlice';
import { useDispatch } from 'react-redux';

const Help = () => {

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        type: '',
        message: ''
    });

    const handleOptionChange = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            type: value
        });
    };

    const handleMessageChange = (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            message: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            dispatch(updateLoader({ loader: true }));
            const response = await Axios.post('/help', formData);
            if (response.data.code === "EC200") {
                toast.success(`${response.data.data.message}`);
                setFormData({
                    type: '',
                    message: ''
                });
            }

            console.log(response.data, 'this is the property request response');
            dispatch(updateLoader({ loader: false }));
        } catch (error) {

            console.error('Error submitting property data:', error);
            dispatch(updateLoader({ loader: false }));
        }
    };

    return (
        <>
            <div className='profile_section'>
                <div className='profile_wrapper'>
                    <div className='container'>
                        <div onClick={() => navigate(-1)} style={{ display: 'flex', justifyContent: 'left', textDecoration: 'none',cursor: 'pointer' }}>
                            <div className='backarrowbtn'>
                                <i className="fa fa-long-arrow-left"></i>
                            </div>
                            <div className="profilebackbtn">Help and feedback</div>

                        </div>

                        <div className='card1 profile_section_wrapper'>
                            <form onSubmit={handleSubmit}>
                                <div className='form-group'>
                                    <label>Help type</label>
                                    <select className='form-control' value={formData.type} onChange={handleOptionChange}>
                                        <option value="" disabled>Please select help type</option>
                                        <option value="How to use IMURAS AGRAW  : Cf : Texte">How to use IMURAS AGRAW  : Cf : Texte</option>
                                        <option value="Trip cancellation by the traveler">Trip cancellation by the traveler</option>
                                        <option value="Trip concellation by the Vendor">Trip concellation by the Vendor</option>
                                        <option value="Refund following trip cancellation">Refund following trip cancellation</option>
                                        <option value="Payment">Payment</option>
                                        <option value="Contact : bye email, phone number">Contact : bye email, phone number</option>
                                    </select>
                                    {errors.option && <p className='error'>{errors.option}</p>}
                                </div>

                                <div className='form-group'>
                                    <label>Your message</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        maxLength={1000}
                                        value={formData.message}
                                        onChange={handleMessageChange}
                                        placeholder='Please enter your message'
                                        style={{resize: 'none'}}
                                    />
                                    {errors.message && <p className='error'>{errors.message}</p>}
                                </div>

                                <button type="submit" className='help_savebtn' disabled={!formData.message || !formData.type}>Save</button>
                            </form>

                            <div className='helpcontactnumber'>
                                <Link to='/privacypolicy'>Claim</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Help;
